import script from "./EvergreenPageDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EvergreenPageDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./EvergreenPageDetailsPopup.vue?vue&type=style&index=0&id=57bc75f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bc75f3"]])

export default __exports__